export class AuthV2VerifySoftwareTokenRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "session",
            "baseName": "session",
            "type": "string",
            "format": ""
        },
        {
            "name": "userCode",
            "baseName": "userCode",
            "type": "string",
            "format": ""
        },
        {
            "name": "friendlyDeviceName",
            "baseName": "friendlyDeviceName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuthV2VerifySoftwareTokenRequest.attributeTypeMap;
    }
    constructor() {
    }
}
